export default "__VITE_ASSET__DadMs5wu__"